export function getImageWithoutCache(url){
    if(!url.includes("http")){
        return url
    }

    const timestamp = new Date().getTime();
    if(url.includes("?")){
        return url + "&time=" + timestamp
    } else {
        return url + "?time=" + timestamp
    }
}